module.exports = __webpack_public_path__ + "static/3.3moveCameraForward-4701552f0d01793eb0832591864623b3.gif";